import { render, staticRenderFns } from "./VsChart.vue?vue&type=template&id=1863690a&scoped=true"
import script from "./VsChart.vue?vue&type=script&lang=js"
export * from "./VsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1863690a",
  null
  
)

export default component.exports